export default {
  registration: {
    name: "Name",
    institution: "Institution",
    component: "Component",
    trainingCourse: "Promotion",
    group: "Group",
    Contact: "contact",
    registration_settings: "Registration settings",
    pedagogicInformations: "Educational information",
    fundingInformations: "Financial information",
    dates: "Dates",
    from_to: "from {from} to {to}",
    hourlyVolume: "Hourly volume",
    hourlyRemoteVolume: ({ named }) => `Of which ${named("volume")} h remotely`,
    modality: ({ plural }) => plural(["Modality", "Modalities"]),
    in_person: "In person",
    distanciel: "Remote",
    remoteVolume: "Including distance learning",
    degreePrepared: "Degree prepared",
    level: "Level",
    titleRncp: "RNCP title",
    degreeCode: "Degree code",
    calendar: "Calendar",
    program: "Program",
    apprenticeShipContract: "Apprenticeship contract",
    proContract: "Professionalization contract",
    rate: "Rate",
    publicAnnualRate: "Annual cost for public-sector employers",
    annualRate: "Annuel cost",
    totalRate: "Total cost",
    hourlyRate: "Hourly rate",
    followUp: "Follow-up",
    devices: "Devices",
    createdAt: "created at {date}",
    help: "Help",
    follow: "Follow",
    inProgress: "In progress",
    validatedAt: "Validated at {date} by {validator}",
    steps: "Steps",
    statistics: "Statistics",
    pending: "Pending",
    publicSector: "Public sector",
    privateSector: "Private sector",
    link_copied_success: "Link successfully copied to the clipboard!",
    head_office: "Head office",
    status: {
      upcoming: "Upcoming ",
      in_progress: "In progress",
      finalised: "Finalised",
      break_up: "Break-up",
      cancelled: "Cancelled",
    },
    insee_company: {
      title: ({ plural }) => plural(["INSEE company ", "INSEE companies"]),
      siret: "SIRET",
      activity: "Activity (NAF/APE)",
      details: "Details (name, sign, address)",
      creation: "Creation",
      state: "State",
      social_reason: "Social reason",
      current: "Current establishment",
      head_office: "Company headquarters",
      creation_date: "Creation date",
      work_force: "Workforce",
      status: "Status",
      principal_address: "Primary address",
      secondary_address: "Secondary address",
      empty_contact: "No contact details are provided for this company",
    },
    training_info: {
      search_by_branch: "Search by collective agreement",
      funding_coverage: "Funding coverage:",
      decree_cost: "Decree cost:",
      only_different_cost_displayed: "By default, only costs different from the decree cost are shown",
      info_tab: {
        general_info: "General information",
        rncp_sheet: "RNCP sheet",
        program: "Program",
        setttings: "Enrollment settings",
        settings: "Enrollment settings",
        npec: "NPEC",
        contact: "contact for companies",
      },
      general_info: {
        institution_name: "Institution name",
        reference: "Reference",
        rncp_number: "RNCP number",
        offical_name: "Official name",
        diplome_type: "Diploma type",
        mention: "Name / mention",
        route: "Pathway",
        diplome_code: "Diploma code",
        status: "Status",
        logo: "Logo",
        partner_website_url: "Partner website URL",
        link: "Link",
        work_study_duration: "Work-study duration",
        total_cycle_time: "Total cycle duration",
        active: "Active",
        archived: "Archived",
      },
    },
    group_action: {
      see_sheet: "View the pre-registration form",
      copy_sheet: "Copy the pre-registration form link",
      create: "Create a pre-registration form",
      see_group_detail: "View group details",
      delete: {
        confirmation: "Are you sure you want to delete this group?",
        success: "Group successfully deleted!",
      },
    },
    creation: {
      info: "To create a new registration form, please first enter the candidate's information",
      success: ({ named }) =>
        `Pre-registration form of ${named("firstName")} ${named("lastName")} successfully created!`,
    },
    user_not_connected: "You must log in to access this area.",
    quote: {
      contract: "Contract",
      financial: "Funding",
      amount: "Amount grid",
      edit_cost: "Edit costs",
      subtitle: "Financial summary of the apprenticeship contract",
      initial_cost: "Initial cost",
      final_cost: "Final cost",
      modal_alert:
        "These changes will affect the amount billed to the company. Make sure the amounts comply with your agreement.",
      discount: ({ named }) => `Commercial discount: ${named("economy")} (${named("discount")})`,
      edit: {
        date: {
          title: "Change the contract dates",
          success: "Contract dates successfully changed!",
        },
        cost: {
          title: "Edit amounts",
          success: "Amounts successfully updated!",
        },
      },
      table: {
        columns: {
          trainingCourseCost: "Training cost",
          opcoo: "Support",
          mandatory_participation: "Mandatory contribution",
          remaining_cost: "Remaining cost",
        },
      },
      duration: {
        title: "Duration",
      },
      startDate: {
        title: "Start date",
      },
      endDate: {
        title: "End date",
      },
    },
    contact: {
      title: "A contact",
      success: "Contact added successfully!",
      delete: {
        confirmation: "Are you sure you want to delete this contact?",
        success: "Contact successfully deleted!",
      },
    },
    contractType: {
      apprentice: "Apprentices",
      pro: "Professional contract",
    },
    document: {
      baseline: "Document to print, sign and upload below",
      cerfa: {
        title: "CERFA",
      },
      convention: {
        title: "Convention",
      },
      update: {
        success: ({ named }) => `Your ${named("document")} has been successfully saved!`,
      },
    },
    step: {
      validation: {
        success: "Step successfully completed!",
      },
    },
    save: {
      success: "Your registration form has been successfully submitted!",
    },
    create: {
      confirmation: "Are you sure you want to create a new pre-registration file?",
    },
    dashboard: {
      go_to: "Access the dashboard for this training",
    },
    alert: {
      title: ({ plural }) => plural(["Alert ", "Alerts"]),
      level: {
        info: "Information",
        warning: "Warning",
        error: "Error",
      },
      active_unactive: "Active/Unactive",
      empty: "No alerts of level {level}",
    },
    contract: {
      empty: "No contract available",
      see: "Access the contract",
    },
    empty_registation_list: "No pre-registration form available",
    empty_document: "No documents",
    company_dashboard: {
      following_contract: {
        title: "List of contracts",
      },
    },
    contract_status: {
      init: "Initialised",
      to_send_to_training_center: "To be sent",
      sent_to_training_center: "Sent",
      validated_training_center: "Validated",
      signed: "Signed",
      error: "Error",
      archived: "Archived",
    },
    years: "years",
    workInProgress: "Work in progress",
    valid: "Validate",
    uaiCode: "UAI code",
    tutor: "Tutor",
    training: "Training",
    totalWorkForce: "Total workforce",
    socialReason: "Company name",
    signIn: "Create account",
    settings: "Settings",
    see_more: "See more",
    pricePolicyInfo3: "The rate is aligned with coverage.",
    pricePolicyInfo2: "Remaining charge only if coverage is below rate; if higher, rate applied based on coverage.",
    pricePolicyInfo1: "Remaining charge only if coverage is less; coverage capped at rate, even if higher.",
    previousSituation: "Previous situation",
    prev: "Previous",
    preContractSituation: "Pre-contract situation",
    phone: "Phone",
    opco: "OPCO",
    noNeedAccount: "I already have an account",
    next: "Next",
    needAccount: "I don't have an account",
    nationality: "Nationality",
    map: "Apprenticeship supervisor",
    male: "Mr.",
    loginInfo2: "Sign in to access the registration form",
    loginInfo: "Sign in or create an account to access the registration form",
    login: "Sign in",
    lastInstitution: "Last institution",
    lastDegreePrepared: "Last degree prepared",
    lastDegreeObtained: "Last degree obtained",
    ineCode: "INE code",
    idcc: "IDCC",
    iAm: "I am",
    hourlyTrainingVolume: "Number of hours",
    hostCompanyContact: "Host company contact",
    hostCompany: "Host company",
    generalInformations: "General information",
    function: "Function",
    firstName: "First name",
    female: "Ms.",
    employerType: "Employer type",
    employerSubType: "Employer subtype",
    email: "Email",
    download_training_sheet: "Download training sheet",
    department: "Department",
    degree: "Degree",
    createCompanyAccount: "Create company account",
    createApprenticeAccount: "Create apprentice account",
    contacts: "Contacts",
    company: "Company",
    civility: "Civility",
    birthDate: "Date of birth",
    apprenticeMaster2: "Apprentice supervisor 2",
    apprenticeMaster: "Apprentice supervisor",
    anApprentice: "An apprentice",
    age: "Age",
    administratorCompanyContact: "Company headquarters contact",
    administratorCompany: "Company headquarters",
    address: "Address",
    activityCode: "Activity code (NAF)",
    accountExistSubTitle: "with the provided email address. Please sign in instead.",
    accountExist: "An account already exists",
    aCompany: "A company",
    endDate: "End date",
    startDate: "Start date",
  },
};
